import styled from "styled-components";
import { Modal as ANTDModal } from "antd";

export const AccountModal = styled(ANTDModal)`
    .ant-modal-header {
        background: #2e3c50;
        border-radius: 12px;
    }

    .ant-modal-title {
        color: white;
    }

    .ant-modal-content {
        border-radius: 12px;
        padding: 2px;
    }

    .ant-modal-close {
        color: white;
    }

    .ant-modal-close:hover{
        color: #aaadb0;
    }

    .ant-modal-close:disabled{
        color: #54575f;
        cursor: no-drop !important;
    }

    .ant-modal-close:focus{
        color: #aaadb0;
        outline: none;
    }

    .modal-content-describe{
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.14;
        letter-spacing: normal;
        text-align: left;
        color: #262e3e;
    }

    .ant-btn:hover, .ant-btn:focus{
        color: #2e3c50;
        border-color: #2e3c50;
    }

    .ant-btn-primary {
        background-color: #2e3c50;
        border-color: #2e3c50;
    }

    .ant-btn-primary:hover, .ant-btn-primary:focus {
        box-shadow: 0 0 14px 0 rgba(82, 93, 110, 0.42);
        background-color: #525d6e;
        border: solid 1px #525d6e;
        color: #ffffff;
    }

    .ant-btn-dangerous:hover, .ant-btn-dangerous:focus {
        box-shadow: 0 0 14px 0 #ff4d4f;
        background-color: #ff4d4f;
        border: solid 1px #ff4d4f;
        color: #ffffff;
    }
`;